module.exports = __webpack_public_path__ + "img/logo_reg_serv_colored.a9ba6cc6.jpg";